export default {
      id: "team-name-usage",
      viewBox: "0 0 200 96",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#team-name",
      toString: function () {
        return this.url;
      }
    }